const DEFAULT_MARKETING_SITE_URL = 'https://www.gitdotme.com';
const DEFAULT_PANEL_SITE_URL = 'https://panel.gitdotme.com';

const getMarketingSiteUrl = () =>
  process.env.REACT_APP_MARKETING_SITE_URL || DEFAULT_MARKETING_SITE_URL;

const getPanelSiteUrl = () =>
  process.env.REACT_APP_PANEL_SITE_URL || DEFAULT_PANEL_SITE_URL;

const toAbsoluteCertificationUrl = path =>
  new URL(path, getMarketingSiteUrl()).toString();

const toAbsolutePanelUrl = path => new URL(path, getPanelSiteUrl()).toString();

const getNormalizedCertificationPath = value => {
  if (!value || typeof value !== 'string') {
    return '';
  }

  if (value.startsWith('/proof/certifications/')) {
    return value;
  }

  if (value.startsWith('/embed/certifications/')) {
    return value;
  }

  try {
    const parsed = new URL(value);

    if (
      parsed.pathname.startsWith('/proof/certifications/') ||
      parsed.pathname.startsWith('/embed/certifications/')
    ) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    return '';
  }

  return '';
};

export const buildCertificationProofPath = proofId =>
  `/proof/certifications/${encodeURIComponent(proofId)}`;

export const buildCertificationMeaningPath = proofId =>
  `${buildCertificationProofPath(proofId)}/meaning`;

export const buildCertificationEmbedPath = proofId =>
  `/embed/certifications/${encodeURIComponent(proofId)}`;

export const buildCertificationProofUrl = proofId =>
  toAbsoluteCertificationUrl(buildCertificationProofPath(proofId));

export const buildCertificationMeaningUrl = proofId =>
  toAbsoluteCertificationUrl(buildCertificationMeaningPath(proofId));

export const buildCertificationEmbedUrl = proofId =>
  toAbsoluteCertificationUrl(buildCertificationEmbedPath(proofId));

export const buildCertificationSignupUrl = proofId =>
  toAbsolutePanelUrl(`/signup?proofID=${encodeURIComponent(proofId)}`);

export const buildMarketingHomeUrl = () => getMarketingSiteUrl();

export const normalizeCertificationPublicUrl = value => {
  const normalizedPath = getNormalizedCertificationPath(value);

  if (!normalizedPath) {
    return value || '';
  }

  return toAbsoluteCertificationUrl(normalizedPath);
};

export const normalizeCertificationBadgeUrls = badge => {
  if (!badge) {
    return badge;
  }

  return {
    ...badge,
    share_url: normalizeCertificationPublicUrl(badge.share_url),
    embed_url: normalizeCertificationPublicUrl(badge.embed_url)
  };
};
